import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { NotAuthorizedComponent } from './core/components/not-authorized/not-authorized.component';
import { DownloadUploaderComponent } from './features/uploader/download-uploader/download-uploader.component';
import { FaqComponent } from './features/uploader/faq/faq.component';
import { ManualComponent } from './features/uploader/manual/manual.component';
import { PasswordSetterComponent } from './core/components/password-setter/password-setter.component';

const routes: Routes = [
  {
    path: 'setup',
    loadChildren: () => import('./core/layouts/setup-layout/setup-layout.module').then(m => m.SetupLayoutModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./core/layouts/product-admin-layout/product-admin-layout.module').then(m => m.ProductAdminLayoutModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./core/layouts/main-layout/main-layout.module').then(m => m.MainLayoutModule)
  },
  {
    path: 'logon',
    loadChildren: () => import('./core/layouts/landingpage-layout/landingpage-layout.module').then(m => m.LandingPageLayoutModule)
  },
  {
    path: 'password-setter/:authcode',
    component: PasswordSetterComponent
  },
  { path: 'uploader/download', component: DownloadUploaderComponent },
  { path: 'uploader/faq', component: FaqComponent },
  { path: 'uploader/manual', component: ManualComponent },
  { path: '404', component: NotFoundComponent },
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: '404', component: NotFoundComponent },
  { path: '401', component: NotAuthorizedComponent },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true
      // , enableTracing: true
    } as ExtraOptions)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
